// テーマ変更用スイッチのモジュール
export default function themeSwitcher() {
  return {
    setTheme(theme) {
      document.documentElement.setAttribute('data-theme', theme)
    },
  }
}